import * as React from "react";
import {Fragment} from "react";
import QuoteStatusChangedNotification from "../../../model/notification/quote/QuoteStatusChangedNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: QuoteStatusChangedNotification
}

/**
 * Quote status changed notification toast body.
 */
const NotificationQuoteStatusChangedBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.leadReferenceNumber}</div>
			<div className={"toast-body"}>
				Quote status changed to {props.notification.data.status}
			</div>
		</Fragment>
	);
};

export default NotificationQuoteStatusChangedBody;
